import { Datepicker } from "@mobiscroll/react5";
import React from "react";
import { Modal } from "react-bootstrap";
import followupSvg from "../../assets/icons/FollowUpButton.svg";
import Button from "../Button";

// import { listTimeSlots } from "src/components/Dashboard/Calendar/api/index";
import { setFollowUp } from "./api";
import Loader from "src/components/Dashboard/common/Loader";
import { useSelector } from "react-redux";

const FollowUp = ({ showFollowUp, setShowFollowUp, title, appointmentId }) => {
  const [openSlots, setOpenSlots] = React.useState([]);

  const [selectedSlot, setSelectedSlot] = React.useState(null);
  const [date, setDate] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loader, setLoader] = React.useState(false);

  const timeSlots = useSelector(state => state.timeslots?.listTimeSlots);

  const changeButton = (id) => {
    setSelectedSlot(id);
  };

  React.useEffect(() => {
    if (date) {
      const startOfGivenDate = new Date(date);
      startOfGivenDate.setHours(0, 0, 0, 0);
      const endOfGivenDate = new Date(date);
      endOfGivenDate.setHours(23, 59, 59, 999);
      const now = new Date();

      const filtered = timeSlots.filter(slot => {
        const slotStartTime = new Date(slot.start);

        // Condition 1: Filter based on "start" field matching the given date
        const isSameDate =
          slotStartTime.getFullYear() === startOfGivenDate.getFullYear() &&
          slotStartTime.getMonth() === startOfGivenDate.getMonth() &&
          slotStartTime.getDate() === startOfGivenDate.getDate();

        // Condition 2: Status should be "Active"
        const isActive = slot.status === "Active";

        // Condition 3: "start" time from now onwards till midnight of given date
        const isFuture = slotStartTime >= now && slotStartTime <= endOfGivenDate;

        return isSameDate && isActive && isFuture;
      });
      setOpenSlots(filtered);
    } else {
      setOpenSlots([]);
    }
  }, [timeSlots, date]);


  const handleSubmit = React.useCallback(
    async (e) => {
      e.preventDefault();
      setLoader(true);
      if (date != null) {
        await setFollowUp({ appointmentId, timeslotId: selectedSlot, });
        setShowFollowUp(false);
      } else {
        setError("Please Select a slot");
      }
      setLoader(false);
    },
    [setFollowUp, appointmentId, selectedSlot]
  );

  return (
    <>
      <Loader show={loader} />
      <Modal
        size="lg"
        show={showFollowUp}
        onHide={() => setShowFollowUp(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="follow-up-dialog-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg" className="ml-3">
            <span className="ModalTitle">{title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="follow-up-body">
            <div className="w-100">
              <Datepicker
                controls={["calendar"]}
                displayTimezone="ist"
                dataTimezone="ist"
                dateFormat="MMMM D, YYYY"
                theme="ios"
                themeVariant="light"
                touchUi
                display="anchored"
                label="Select Consultation Date"
                inputProps={{
                  inputStyle: "box",
                  labelStyle: "floating",
                  placeholder: "Please select",
                }}
                onChange={(e) => {
                  console.log(e);
                  setDate(new Date(e.value));
                }}
                value={date}
              />
            </div>
            <div className="follow-modal-header" style={{ marginTop: "20px" }}>
              <span className={`${error ? "mbsc-error-message mbsc-ios" : ""}`}>
                Pick the time slot
              </span>
              <div className="slot-button">
                {date == null ? (
                  "Please Select Date to pick the time slot!"
                ) : (
                  <>
                    {openSlots.length > 0
                      ? openSlots.map((slot) => {
                        return (
                          <Button
                            name={`${new Date(slot.start).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              }
                            )} - ${new Date(slot.end).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}`}
                            className={`col newAppointment height-35 no-box-shadow ${slot.id === selectedSlot ? "" : "non-selected"
                              }`}
                            text={"text-white "}
                            onClick={() => {
                              changeButton(slot.id);
                            }}
                          />
                        );
                      })
                      : "No Slots Found"}
                  </>
                )}
              </div>
            </div>
            <div className="follow-up-button mt-4 d-flex align-items-center justify-content-center">
              <button
                disabled={selectedSlot == null}
                onClick={handleSubmit}
                className="docg-save-btn"
              >
                <img className="follow-up-img" src={followupSvg} alt="" />
                {title}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FollowUp;
